import ReCaptcha from "../reCAPTCHA/ReCaptcha";
import ACTION from "../reCAPTCHA/Constants";

class App {
    constructor(config) {
        this.reCaptcha = new ReCaptcha(config);
        this.esMop = config.esMop;
        $("#username").rut();
        document.getElementById('username').addEventListener("keypress", e => {
            this.submitLogin(e);
        });
        document.getElementById('password').addEventListener("keypress", e => {
            this.submitLogin(e);
        });
        document.getElementById("submitLoginButton").addEventListener("click", ()=>{
            this.submitLogin();
        });
        $('[data-popup="popover"]').popover();
    }

    submitLogin(event) {
        if (event === undefined || event.keyCode === 13) {
            document.querySelector("#submitLoginButton").disabled = true;
            if (this.esMop) {
                document.getElementById('username').dispatchEvent(new Event('blur', { bubbles: true }));
            }
            requestAnimationFrame(() => {
                if (document.getElementById('username').reportValidity() && document.getElementById('password').reportValidity()) {
                    if (this.reCaptcha.isActive()) {
                        this.reCaptcha.executeCaptcha(ACTION.LOGIN);
                    } else {
                        globalThis.onSubmitFn.call(); // fn global
                    }
                } else {
                    document.querySelector("#submitLoginButton").disabled = false;
                }
            });
        }
    }
}

new App(config);
